import { WeightInput } from '@src/common/components/WeightInput';
import { css } from '@src/common/styles/Styles';
import type { Control, FieldPath, FieldValues, Path } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface Props<T extends FieldValues> {
  control: Control<T>;
  fieldName: Path<T>;
  label?: string;
  name?: string;
  disabled?: boolean;
  displayUnits?: boolean;
  ariaLabel?: string;
  tabIndex?: number;
  multiplyByThousand?: boolean;
  endAdornment?: JSX.Element;
}

export const FormWeightInput = <T extends FieldValues>({
  control,
  name,
  fieldName,
  disabled,
  label,
  ariaLabel,
  displayUnits,
  tabIndex,
  multiplyByThousand,
  endAdornment,
}: Props<T>) => {
  const { t } = useTranslation();

  return (
    <Controller
      control={control}
      render={({
        field,
        fieldState: { error },
        formState: { disabled: formDisabled },
      }) => (
        <WeightInput
          {...field}
          tabIndex={tabIndex}
          readOnly={disabled || formDisabled}
          className={fullWidth}
          label={label ?? t(`fields.${fieldName}`)}
          error={error && t(`formErrors.${error!.message}`)}
          displayUnits={displayUnits}
          ariaLabel={ariaLabel}
          multiplyByThousand={multiplyByThousand}
          endAdornment={endAdornment}
        />
      )}
      name={(name ?? fieldName) as FieldPath<T>}
    />
  );
};

const fullWidth = css({
  flex: 1,
});
